import React, { useRef, useEffect, useLayoutEffect } from 'react';
import classNames from 'classnames';
import Box from '../box';
import Tag from '../tag';

const MAX_PROGRESS = 100;

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const Preloader = ({
  progress = 0,
  label = '',
  isRounded = false,
  isAnimated = false,
  indeterminate = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onAnimationEnd = null,
}) => {
  const fill = useRef(null);

  const preloaderClassName = classNames('ws-ui-preloader', {
    'ws-ui-preloader--rounded': isRounded,
    'ws-ui-preloader--animated': isAnimated,
    'ws-ui-preloader--indeterminate': indeterminate,
  });

  useEffect(() => {
    if (!onAnimationEnd || !fill?.current || progress !== MAX_PROGRESS) return;
    const el = fill.current;
    el.addEventListener('transitionend', onAnimationEnd);
    // eslint-disable-next-line consistent-return
    return () => {
      el.removeEventListener('transitionend', onAnimationEnd);
    };
  }, [onAnimationEnd, progress]);

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      if (!fill.current || !progress) return;
      fill.current.style.width = `${progress}%`;
    });
  }, [progress]);

  return (
    <div className={preloaderClassName}>
      <div className="ws-ui-preloader__line">
        <div ref={fill} className="ws-ui-preloader__fill" />
      </div>
      {label && (
        // @ts-ignore TS(2322): Type '{ children: Element; marginTop: string; }' i... Remove this comment to see the full error message
        <Box marginTop="spacing-3-xs">
          <Tag label={label} />
        </Box>
      )}
    </div>
  );
};

export default Preloader;
